import React, { useState, useRef, useEffect,useContext } from "react";
import { ObjectLiteral } from "../../../interfacesProps/ObjectLiteralProps";
import { ProfileCardSection } from "./ProfileCardSection";
import { ErrorMessageProps, Form, Formik } from "formik";
import { RBButton, RBButtonType } from "../../../components/RBButton";
import { Colors, Spacing } from "../../../theme/Theme";
import { ColumnStyle, skillTextStyle } from "../../../theme/ComponentTheme";
import {
  RenderTextWithTitle,
  renderTextWithTitleForSkills,
  renderTextWithTitleAndChildComponent,
} from "../../../components/TextWithHeader";
import { Schema } from "../YupSchema";
import {
  RBTextFieldForForm,
  RBTextFieldForFormFieldType,
  RBSelectForForm,
  RBMultipleSelectForForm
} from "../../../components/RBTextField";
import { PharmacyRxCounts, NotAvailableString, InvoiceRecipientContactMethod } from "../../../util/Common";
import { SkillResponseDto } from "../../../dtos/Skill.dto";
import { PharmacyService } from "../../../api/PharmacyService";
import { SkillType } from "../../../util/Enumeration";
import { MenuItem, ListItemText, Typography,Checkbox, FormControlLabel } from "@material-ui/core";
import { RBPlaceSearchForForm2 } from "../../../components/RBPlaceSearch";
import { AuthService } from "../../../api/AuthService";
import NotificationService, {
  NotificationServiceTopic,
} from "../../../api/NotificationService";
import { RBMap } from "../../../components/RBMap";
import formatService from "../../../util/FormattingService";
import { LabelText } from "../../../util/TextConstant";
import { RBContext } from "../../../components/RBContext";
import { RBEmptyBlock } from "../../../components/RBEmptyBlock";
import * as Yup from "yup";
import { Regexes } from "../../../util/Default";
import { LocationStats } from "../../../components/LocationStats";
import { AxiosError } from "axios";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import _ from "lodash";
interface PharmacyDetailSectionProps {
  accountInfo: ObjectLiteral;
}

interface Address {
  apartmentSuiteNumber: string;
  streetAddress: string;
  city: string;
  province: string;
  postalCode: string;
}

interface Skill {
  required: boolean;
  skillId: string; // Assuming skillId is a string, modify if needed
}

interface Payload {
  pharmacyId: string; // Assuming pharmacyId is a string, modify if needed
  phone: string;
  fax: string;
  storeNumber: string;
  rxCount: number;
  name: string;
  skills: Skill[];
  address: Address;
  contactFirstName: string;
  contactLastName: string;
  contactPhone: string;
  invoiceRecipient: string;
  billingEmail?: string;
  notifyAdminOnBillingEmailChange?: boolean;
  about: string;
  acceptedEmploymentTypes?: string[];
}

enum PreferredEmployeeType {
  Employee = 'Employee',
  ICSoleProprietor = 'Independent Contractor - Sole Proprietor',
  ICIncorporated = 'Independent Contractor - Incorporated',
}

export const PharmacyDetailSection: React.FC<PharmacyDetailSectionProps> = ({
  ...props
}) => {
  const { industryMode,primaryColor,secondaryColor } = useContext(RBContext);
  const { accountInfo } = props;
  const defaultPharmacyId =
    accountInfo.owner.defaultPharmacyId ?? accountInfo.pharmacies[0].id;
  const pharmacy = accountInfo.pharmacies.filter(
    (pharmacy: { id: any }) => pharmacy.id === defaultPharmacyId
  )[0];
  const [isEdit, setIsEdit] = useState(false);
  const formRef = useRef<any>();
  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const addressRef = useRef<any>();

  const [skillsByType, setSkillsByType] = useState<Record<string, SkillResponseDto[]>>({});
  const [isBillingEnabled, setIsBillingEnabled] = useState(pharmacy.invoiceRecipient === InvoiceRecipientContactMethod[0].id ? true : false);
  const [invoiceRecipientArr, setInvoiceRecipientArr] = useState<any>(pharmacy.invoiceRecipient === InvoiceRecipientContactMethod[0].id ?
    [InvoiceRecipientContactMethod[0]] : InvoiceRecipientContactMethod.filter(contact => contact.id !== InvoiceRecipientContactMethod[0].id),);
  const [isBillingEnabledSaved, setIsBillingEnabledSaved] = useState(pharmacy.invoiceRecipient === InvoiceRecipientContactMethod[0].id ? true : false);
  const acceptedEmploymentTypes = pharmacy.acceptedEmploymentTypes || [];
  const initialPaymentMethods = {
    employee: acceptedEmploymentTypes.includes(PreferredEmployeeType.Employee),
    independentSole: acceptedEmploymentTypes.includes(PreferredEmployeeType.ICSoleProprietor),
    independentIncorporated: acceptedEmploymentTypes.includes(PreferredEmployeeType.ICIncorporated),
  };
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState(initialPaymentMethods);
  const isAcceptedEmploymentTypesEnabled = props.accountInfo.networks[0].isAcceptedEmploymentTypesEnabled;
   const { locationMultiSelects } = accountInfo?.networks?.[0].skillSet;

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const setLoadingValue = (value: boolean) => {
    isMountedRef.current && setIsLoading(value);
  };

  // useEffect(() => {
  //   if (isEdit) {
  //     setSelectedPaymentMethods({
  //       employee: acceptedEmploymentTypes.includes(PreferredEmployeeType.Employee),
  //       independentSole: acceptedEmploymentTypes.includes(PreferredEmployeeType.ICSoleProprietor),
  //       independentIncorporated: acceptedEmploymentTypes.includes(PreferredEmployeeType.ICIncorporated),
  //     });
  //   }
  // }, [isEdit, acceptedEmploymentTypes]);

  const fetchSkills = async () => {
    try {
      setLoadingValue(true);
       const skillTypes = accountInfo?.networks?.[0]?.skillSet?.locationSkillSets || [];
            const fetchSkillsData = await PharmacyService.fetchSkills(skillTypes,industryMode);
            const groupedSkills = fetchSkillsData.data.reduce((acc: any, skill: any) => {
              const type = skill.type || 'unknown';
              if (!acc[type]) {
                acc[type] = [];
              }
              acc[type].push(skill);
              return acc;
            }, {});   
            setSkillsByType(groupedSkills); 
    } catch (err) {
     const errorMessage = (err as any).response ? (err as any).response.data : (err as any).message;
      setSubmitErrorMessage(errorMessage);
    } finally {
      setLoadingValue(false);
    }
  };
  const renderAddress = () => {
    const [lng, lat] = pharmacy.address.coordinate.coordinates;
    const addressFormat = pharmacy.address.apartmentSuiteNumber
      ? pharmacy.address.apartmentSuiteNumber +
        " - " +
        pharmacy.address.streetAddress +
        " \n " +
        pharmacy.address.city +
        " " +
        pharmacy.address.province +
        " \n " +
        pharmacy.address.postalCode
      : pharmacy.address.streetAddress +
        "\n" +
        pharmacy.address.city +
        " " +
        pharmacy.address.province +
        "\n" +
        pharmacy.address.postalCode;
    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Pharmacy Address", addressFormat)}
          <RBMap
            style={{
              display: "flex",
              flex: 1,
              height: 200,
              marginTop: Spacing.medium,
            }}
            lat={lat}
            lng={lng}
          />
        </div>
      </>
    );
  };


  const editDetail = () => {
    const PharmacyDetailSection = Yup.object().shape({
      pharmacyName: Yup.string().required("Required"),
      pharmacyStoreNumber: Yup.string(),
      pharmacyPhone: Yup.string()
        .required("Required")
        .matches(Regexes.PhoneValidation, "Invalid phone number"),
      pharmacyFax: Yup.string().required("Required")
      .matches(Regexes.PhoneValidation, "Invalid fax number"),
      pharmacyRxAccount: Yup.string().required("Required"),
      pharmacySoftware: Yup.string().required("Required"),
      pharmacyDesignatedManagerFirstName: Yup.string().required("Required"),
      pharmacyDesignatedManagerLastName: Yup.string().required("Required"),
      pharmacyDesignatedManagerPhone: Yup.string()
        .required("Required")
        .matches(Regexes.PhoneValidation, "Invalid phone number"),
      InvoiceRecipientContact: Yup.string().required("Required"),
      billingEmail: Yup.mixed().when('isBillingEnabled', {
        is: false,
        then: Yup.string()
          .required('Required')
          .matches(Regexes.emailPattern, 'Must be a valid email address')
          .test('is-not-owner-email', 'Billing email is same as owner email', function (value) {
            return value?.toLowerCase() !== localStorage.getItem('ownerEmail')?.toLowerCase();
          }),
        otherwise: Yup.mixed().nullable(true),
      }),
      about: Yup.string().max(600, "Maximum 600 characters allowed"),
        ...Object.keys(skillsByType).reduce((acc, type) => {
                    acc[`skill_${type}`] = Yup.string().required("Required");
                    return acc;
                  }, {} as Record<string, Yup.StringSchema>),
    });
    
     const initialSkills: Record<string, string> = {};

    Object.entries(skillsByType).forEach(([type, skills]) => {
      const fieldName = `skill_${type}`;
      const isMultiSelect = locationMultiSelects.includes(type);

      const matchedSkills = pharmacy.skills.filter((phSkill: any) =>
        skills.some((skill) => skill.id === phSkill.id)
      );

      if (isMultiSelect) {
        // Set all matching skills as an array
        initialSkills[fieldName] = matchedSkills.map((s:any) => s.id);
      } else {
        // Set the first match as a string, or fallback
        initialSkills[fieldName] = matchedSkills.length > 0 ? matchedSkills[0].id : "";
      }
    });

    return (
      <Formik
        innerRef={formRef as any}
        initialValues={{
          pharmacyName: pharmacy.name,
          pharmacyStoreNumber: pharmacy.storeNumber ? pharmacy.storeNumber : "",
          pharmacyPhone: pharmacy.phone,
          pharmacyFax: pharmacy.fax ? pharmacy.fax :"",
          pharmacyRxAccount: pharmacy.rxCount,
          pharmacySoftware:
            pharmacy.skills.length > 0 ? pharmacy.skills[0].id : undefined,

          street: pharmacy.address.streetAddress,
          city: pharmacy.address.city,
          postalCode: pharmacy.address.postalCode,
          province: pharmacy.address.province,
          apartmentSuiteNumber: pharmacy.address.apartmentSuiteNumber,

          pharmacyDesignatedManagerFirstName: pharmacy.contactFirstName,
          pharmacyDesignatedManagerLastName: pharmacy.contactLastName,
          pharmacyDesignatedManagerPhone: pharmacy.contactPhone,
          InvoiceRecipientContact: pharmacy.invoiceRecipient,
          billingEmail:pharmacy.billingEmail ?? null,
          isBillingEnabled:pharmacy.invoiceRecipient === InvoiceRecipientContactMethod[0].id,
          about: pharmacy.about || "",
           ...initialSkills
        }}
        validationSchema={PharmacyDetailSection}
        validateOnBlur={true}
        validateOnMount={true}
        validateOnChange={true}
        isInitialValid={PharmacyDetailSection.isValidSync({
          pharmacyName: pharmacy.name,
          pharmacyStoreNumber: pharmacy.storeNumber ? pharmacy.storeNumber : "",
          pharmacyPhone: pharmacy.phone,
          pharmacyFax: pharmacy.fax ? pharmacy.fax :"",
          pharmacyRxAccount: pharmacy.rxCount,
          pharmacySoftware:
            pharmacy.skills.length > 0 ? pharmacy.skills[0].id : undefined,

          street: pharmacy.address.streetAddress,
          city: pharmacy.address.city,
          postalCode: pharmacy.address.postalCode,
          province: pharmacy.address.province,
          apartmentSuiteNumber: pharmacy.address.apartmentSuiteNumber,

          pharmacyDesignatedManagerFirstName: pharmacy.contactFirstName,
          pharmacyDesignatedManagerLastName: pharmacy.contactLastName,
          pharmacyDesignatedManagerPhone: pharmacy.contactPhone,
          InvoiceRecipientContact: pharmacy.invoiceRecipient,
          billingEmail:pharmacy.billingEmail,
           ...initialSkills
        })}
        onSubmit={() => {}}
      >
        {({
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          validateField
        }) => (
          <Form onSubmit={handleSubmit}>
            {submitErrorMessage && (
              <div style={{ color: "red" }}>
                {JSON.stringify(submitErrorMessage, null, 2)}
              </div>
            )}
            {renderTextWithTitleAndChildComponent(
              "Pharmacy Name",
              <RBTextFieldForForm
                value={values.pharmacyName}
                name="pharmacyName"
                FieldType={RBTextFieldForFormFieldType.default}
                size={"small"}
                style={{ marginBottom: Spacing.large }}
                onChange={handleChange}
              />
            )}
            {renderTextWithTitleAndChildComponent(
              "Pharmacy Store Number",
              <RBTextFieldForForm
                value={values.pharmacyStoreNumber}
                placeholder="Optional"
                name="pharmacyStoreNumber"
                FieldType={RBTextFieldForFormFieldType.default}
                size={"small"}
                style={{ marginBottom: Spacing.large }}
                onChange={handleChange}
              />
            )}
            {renderTextWithTitleAndChildComponent(
              "Pharmacy Phone",
              <RBTextFieldForForm
                value={values.pharmacyPhone}
                name="pharmacyPhone"
                FieldType={RBTextFieldForFormFieldType.phone}
                size={"small"}
                style={{ marginBottom: Spacing.large }}
                onChange={handleChange}
              />
            )}

            {renderTextWithTitleAndChildComponent(
              "Pharmacy Fax",
              <RBTextFieldForForm
                value={values.pharmacyFax}
                name="pharmacyFax"
                FieldType={RBTextFieldForFormFieldType.phone}
                size={"small"}
                style={{ marginBottom: Spacing.large }}
                onChange={handleChange}
              />
            )}

            {renderTextWithTitleAndChildComponent(
              LabelText.DailyAvgRxCount,
              <RBSelectForForm
                value={values.pharmacyRxAccount}
                name="pharmacyRxAccount"
                mappingValues={PharmacyRxCounts}
                style={{ marginBottom: Spacing.large }}
                onChange={handleChange}
              />
            )}
            {Object.entries(skillsByType).map(([type, skills]) => {
              const fieldName = `skill_${type}`;
              const isMultiSelect = locationMultiSelects.includes(type);

              return (
                isMultiSelect ?
                  renderTextWithTitleAndChildComponent(
                    `${type.charAt(0).toUpperCase() + type.slice(1)}`,
                    <RBMultipleSelectForForm
                      key={type}
                      //label={type.includes('specialization') ? 'Skills' : _.startCase(type)} // "Software", "Specialization", etc.
                      name={fieldName}
                      value={Array.isArray((values as Record<string, any>)[fieldName])
                        ? (values as Record<string, any>)[fieldName]
                        : [(values as Record<string, any>)[fieldName]]
                      }
                      onChange={(event: any) => {
                        const value = event.target.value;
                        setFieldValue(fieldName, Array.isArray(value) ? value : [value]);
                      }}
                      renderValue={(selected) => {
                        const selectedArray = Array.isArray(selected) ? selected : [selected];
                        return (
                          <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                            {selectedArray.map((skillID) => {
                              const skill = skills.find((s) => s.id === skillID);
                              return (
                                <div key={skillID} style={skillTextStyle}>
                                  {skill?.name}
                                </div>
                              );
                            })}
                          </div>
                        );
                      }}
                      style={{ marginBottom: Spacing.small }}
                    >
                      {skills.map((skill) => {

                        return (
                          <MenuItem key={skill.id} value={skill.id}>
                            <Checkbox
                              checked={(values as Record<string, any>)[fieldName]?.indexOf(skill.id) > -1}
                              style={{
                                color:
                                  (values as Record<string, any>)[fieldName]?.indexOf(skill.id) > -1
                                    ? localStorage.getItem("secondaryColor") ?? Colors.themeLightBlue
                                    : Colors.darkGrey,
                              }}
                            />
                            <ListItemText primary={skill.name} />
                          </MenuItem>
                        )
                      })}
                    </RBMultipleSelectForForm>
                  )
                  :

                  renderTextWithTitleAndChildComponent(
                    `${type.charAt(0).toUpperCase() + type.slice(1)}`,
                    <RBSelectForForm
                      key={type}
                      name={fieldName}
                      value={
                        skills.some((s) => s.id === (values as Record<string, any>)[`skill_${type}`])
                          ? (values as Record<string, any>)[`skill_${type}`]
                          : ""
                      }
                      renderValue={(value) => {
                        const selected = skills.find((s) => s.id === value);
                        return <div>{selected?.name || NotAvailableString}</div>;
                      }}
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                    >
                      {skills.map((skill) => (
                        <MenuItem key={skill.id} value={skill.id}>
                          <ListItemText primary={skill.name} />
                        </MenuItem>
                      ))}
                    </RBSelectForForm>
                  )
              )
            })}

            {renderTextWithTitleAndChildComponent(
              "About Us (Shift specific information for the Pharmacy)",
              <div>
                <RBTextFieldForForm
                  value={values.about}
                  name="about"
                  FieldType={RBTextFieldForFormFieldType.default}
                  size={"small"}
                  multiline
                  rows={4}
                  style={{ marginBottom: Spacing.small }}
                  onChange={handleChange}
                  inputProps={{ maxLength: 600 }}
                  placeholder="Provide important information to inform workers on what to expect. Details such as parking, dress code, etiquette, expectations, etc., are very helpful. This is visible by the workers when you post shifts."
                />
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                <div style={{ color: Colors.darkGrey, fontSize: '12px', textAlign: 'right' }}>
                  {values.about.length}/600 characters
                </div>
                {values.about.length === 600 && (
                  <div style={{ color: 'red', fontSize: '12px', textAlign: 'right' }}>
                    Maximum character limit reached
                  </div>
                )}
                </div>
              </div>
            )}
            <div style={{ ...ColumnStyle, alignItems: "center" }}>

            {/* {isAcceptedEmploymentTypesEnabled && (
              <div style={{...ColumnStyle, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: Spacing.large}}>
                <Typography variant="h6">We prefer to pay workers as:</Typography>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <FormControlLabel
                    control={
                      <Checkbox 
                        name="employee" 
                        checked={selectedPaymentMethods.employee} 
                        onChange={(e) => handlePaymentMethodChange(e, setFieldValue)} 
                        style={{ color: primaryColor }} 
                      />
                    }
                    label="Employee"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox 
                        name="independentSole" 
                        checked={selectedPaymentMethods.independentSole} 
                         onChange={(e) => handlePaymentMethodChange(e, setFieldValue)} 
                        style={{ color: primaryColor }} 
                      />
                    }
                    label="Independent Contractor - Sole Proprietor"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox 
                        name="independentIncorporated" 
                        checked={selectedPaymentMethods.independentIncorporated} 
                        onChange={(e) => handlePaymentMethodChange(e, setFieldValue)} 
                        style={{ color: primaryColor }} 
                      />
                    }
                    label="Independent Contractor - Incorporated"
                  />
                </div>
              </div>
            )} */}
            </div>
             <div style={{ ...ColumnStyle, alignItems: "center" }}>

            <Typography style={{ display: "flex", flex: 1 }}>
              Billing email is same as owner email?
            </Typography>
            <RBEmptyBlock />
            <Checkbox
              checked={isBillingEnabled}
              style={{
                color: isBillingEnabled
                  ? localStorage.getItem("secondaryColor") ?? Colors.themeLightBlue
                  : Colors.darkGrey,
              }}
              name="isBillingEnabled"
              onBlur={handleBlur}
              onChange={(_, checked) => {
                setIsBillingEnabled(!isBillingEnabled);
                setFieldValue("isBillingEnabled", checked);
                const updatedBillingEnabled = checked;

                if (updatedBillingEnabled) {
                  setInvoiceRecipientArr([InvoiceRecipientContactMethod[0]]);
                  setFieldValue("InvoiceRecipientContact", InvoiceRecipientContactMethod[0].id);
                } else {
                  setInvoiceRecipientArr(
                    InvoiceRecipientContactMethod.filter(contact => contact.id !== InvoiceRecipientContactMethod[0].id)
                  );
                  setFieldValue("InvoiceRecipientContact", InvoiceRecipientContactMethod[2].id);
                  setFieldValue("billingEmail", pharmacy.billingEmail !== null ? pharmacy.billingEmail : '' )

                  if (!isBillingEnabledSaved) {
                    setFieldValue("InvoiceRecipientContact", pharmacy.invoiceRecipient);
                  }
                }
              }}
            />

          </div>
          { (!isBillingEnabled) &&
            renderTextWithTitleAndChildComponent('Billing Email',
               <RBTextFieldForForm
               value={values.billingEmail}
               name="billingEmail"
               size={"small"}
               style={{ marginBottom: Spacing.large }}
               onChange={async (e:any) => {
                const { value } = e.target;
                handleChange(e)
                await setFieldValue('billingEmail', value);
                // Force validate the InvoiceRecipientContact field immediately
                validateField('billingEmail');
                
              }
              }
               onBlur={handleBlur}
             />
            
            )}

            {renderTextWithTitleAndChildComponent('Invoice Recipient',
               <RBSelectForForm
               name="InvoiceRecipientContact"
               value={values.InvoiceRecipientContact}
               onChange={async (e:any) => {
                 const { value } = e.target;
                 handleChange(e)
                 await setFieldValue('InvoiceRecipientContact', value);
                 // Force validate the InvoiceRecipientContact field immediately
                 validateField('InvoiceRecipientContact');
                 
               }
               }
               onBlur={handleBlur}
               placeholder={"Please select ..."}
               style={{
                 marginBottom: Spacing.large,
               }}
             >
               {invoiceRecipientArr.map((recipient:any) => (
                 <MenuItem key={recipient.id} value={recipient.id}>
                   <div>{recipient.value}</div>
                 </MenuItem>
               ))}
             </RBSelectForForm>
            
            )}

            

            <div
              style={{
                height: 1,

                marginTop: Spacing.large,
                marginBottom: Spacing.large,
              }}
            />
            <RBPlaceSearchForForm2
              innerRef={addressRef}
              initialValues={{
                street: pharmacy.address.streetAddress,
                city: pharmacy.address.city,
                postalCode: pharmacy.address.postalCode,
                province: pharmacy.address.province,
                apartmentSuiteNumber: pharmacy.address.apartmentSuiteNumber,
              }}
              isProvinceEditable={false}
            />
            <div
              style={{
                height: 1,

                //marginTop: Spacing.large,
                marginBottom: Spacing.large,
              }}
            />
            {renderTextWithTitleAndChildComponent(
              "Designated Manager First Name",
              <RBTextFieldForForm
                value={values.pharmacyDesignatedManagerFirstName}
                name="pharmacyDesignatedManagerFirstName"
                FieldType={RBTextFieldForFormFieldType.default}
                size={"small"}
                style={{
                  marginBottom: Spacing.large,
                }}
                onChange={handleChange}
              />
            )}
            {renderTextWithTitleAndChildComponent(
              "Designated Manager Last Name",
              <RBTextFieldForForm
                value={values.pharmacyDesignatedManagerLastName}
                name="pharmacyDesignatedManagerLastName"
                FieldType={RBTextFieldForFormFieldType.default}
                size={"small"}
                style={{ marginBottom: Spacing.large }}
                onChange={handleChange}
              />
            )}
            {renderTextWithTitleAndChildComponent(
              "Designated Manager Phone",
              <RBTextFieldForForm
                value={values.pharmacyDesignatedManagerPhone}
                name="pharmacyDesignatedManagerPhone"
                FieldType={RBTextFieldForFormFieldType.default}
                size={"small"}
                style={{ marginBottom: Spacing.large }}
                onChange={handleChange}
              />
            )}
          </Form>
        )}
      </Formik>
    );
  };
  const renderDetail = () => {
    console.log(
      "PharmacyDetailSection render detail pharmacy",
      defaultPharmacyId,
      accountInfo,
      pharmacy
    );
   const skills = pharmacy.skills || [];
    const skillSets =accountInfo?.networks?.[0]?.skillSet?.locationSkillSets || [];

     const singleSkillType = skillSets.length === 1 ? skillSets[0] : null;
    const singleSkillValues = singleSkillType
      ? skills.filter((skill:any) => skill.type === singleSkillType).map((skill:any) => skill.name)
      : [];

    const capitalizedSingleTitle = singleSkillType
      ? singleSkillType.charAt(0).toUpperCase() +
      singleSkillType.slice(1) +
      (singleSkillType === 'specialization' ? 's' : '')
      : '';
    const selectedInvoiceRecipient = InvoiceRecipientContactMethod.find(method => method.id === pharmacy.invoiceRecipient);
    const displayInvoiceRecipient = selectedInvoiceRecipient ? selectedInvoiceRecipient.value : 'N/A';
    return (
      <>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Pharmacy Name", pharmacy.name)}
          {pharmacy.storeNumber ? RenderTextWithTitle("Store Number", pharmacy.storeNumber):RenderTextWithTitle("Store Number", "N/A") }
        </div>
        {renderAddress()}
        <div style={ColumnStyle}>
          {RenderTextWithTitle(
            "Pharmacy Phone",
            formatService.formatPhoneNumber(pharmacy.phone)
          )}
          {pharmacy.fax
            ? RenderTextWithTitle(
                "Pharmacy Fax",
                formatService.formatPhoneNumber(pharmacy.fax)
              )
            : RenderTextWithTitle("Pharmacy Fax", "N/A")}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle("Avg Rx Account", pharmacy.rxCount)}

            {skillSets.length === 1 &&
                               renderTextWithTitleForSkills(capitalizedSingleTitle, singleSkillValues)}
        </div>
          {skillSets.length > 1 &&
                          skillSets.map((skillType:any) => {
                            const matchedSkills = skills
                              .filter((skill:any) => skill.type === skillType)
                              .map((skill:any) => skill.name);
                
                            const capitalizedTitle =
                              skillType.charAt(0).toUpperCase() +
                              skillType.slice(1) +
                              (skillType === 'specialization' ? 's' : '');
                
                            return (
                               <div style={ColumnStyle}>
                                {renderTextWithTitleForSkills(capitalizedTitle, matchedSkills)}
                              </div>
                            );
                          })}
        <div style={ColumnStyle}>
          {RenderTextWithTitle(
            "Manager Name",
            pharmacy.contactFirstName + " " + pharmacy.contactLastName
          )}
          {RenderTextWithTitle(
            "Manager Phone",
            formatService.formatPhoneNumber(pharmacy.contactPhone)
          )}
        </div>
        <div style={ColumnStyle}>
          {RenderTextWithTitle(
            "Manager License Number",
            pharmacy.contactLicenseNumber
          )}
           {RenderTextWithTitle(
            "Invoice Recipient",
            displayInvoiceRecipient
          )}
        </div>
        { selectedInvoiceRecipient?.id !== InvoiceRecipientContactMethod[0].id &&
        <div style={ColumnStyle}>
           {RenderTextWithTitle(
            "Billing Email",
            pharmacy.billingEmail
          )}
        </div>
        }

          <div style={ColumnStyle}>
          {RenderTextWithTitle(
            "About Us (Shift specific information for the Pharmacy)",
            pharmacy.about || <span style={{ color: Colors.darkGrey, fontSize: '14px', whiteSpace: 'pre-wrap' }}>
            Provide important information to inform workers on what to expect. Details such as parking, dress code, etiquette, expectations, etc., are very helpful. This is visible by the workers when you post shifts.
          </span>
          )}
        </div>

        {/* {isAcceptedEmploymentTypesEnabled && (
          <div style={{...ColumnStyle, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: Spacing.large}}>
            <Typography style={{fontWeight: 'bold'}}>Payment Preference</Typography>
            {Array.isArray(acceptedEmploymentTypes) && acceptedEmploymentTypes.length === 0 && (
              <Typography variant="body2" style={{ color: Colors.darkGrey }}>
                Choose the methods in which you prefer to pay workers
              </Typography>
            )}
            {acceptedEmploymentTypes.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column'}}>
               {(acceptedEmploymentTypes || []).map((method: string) => (
                 <FormControlLabel
                   key={method}
                   control={
                     <Checkbox
                       checked={true}
                       icon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                       checkedIcon={<CheckCircleIcon style={{ color: secondaryColor }} />}
                     />
                   }
                   label={method}
                 />
               ))}
             </div>
            )}
          </div>
        )} */}

        <div
          style={{
            height: 1,
            backgroundColor: 'lightgray',
            marginTop:10,
            marginBottom:10
          }}
        />
        <LocationStats account={pharmacy} />
      </>
    );
  };
  const onSaveChange = async () => {
    try {
      if (formRef.current) {
        if (addressRef.current) {
          addressRef.current.handleSubmit();
        }

        formRef.current.handleSubmit();

        if (!formRef.current.isValid) {
          console.log("pharmacy detail is not Valid ", formRef.current);
          return;
        } else if (!addressRef.current.isValid) {
          console.log(
            "pharmacy detail address is not Valid ",
            addressRef.current
          );
          return;
        } else {
          setLoadingValue(true);
          console.log("pharmacy detail onSaveChange ", formRef.current.values);
          const skillPayload: Skill[] = Object.entries(formRef.current.values)
            .filter(([key, value]) => key.startsWith("skill_") && value)
            .flatMap(([_, value]) => {
              const skillIds = Array.isArray(value) ? value : [value]; // normalize to array
              return skillIds.map((skillId) => ({
                required: true,
                skillId,
              }));
            });
          let payload:Payload = {
            pharmacyId: pharmacy.id,
            phone: formRef.current.values.pharmacyPhone,
            fax: formRef.current.values.pharmacyFax,
            storeNumber: formRef.current.values.pharmacyStoreNumber,
            rxCount: formRef.current.values.pharmacyRxAccount,
            name: formRef.current.values.pharmacyName,
             skills: skillPayload,
            address: {
              apartmentSuiteNumber:
                addressRef.current.values.apartmentSuiteNumber,
              streetAddress: addressRef.current.values.street,
              city: addressRef.current.values.city,
              province: addressRef.current.values.province,
              postalCode: addressRef.current.values.postalCode,
            },
            contactFirstName:
              formRef.current.values.pharmacyDesignatedManagerFirstName,
            contactLastName:
              formRef.current.values.pharmacyDesignatedManagerLastName,
            contactPhone: formRef.current.values.pharmacyDesignatedManagerPhone,
            invoiceRecipient: formRef.current.values.InvoiceRecipientContact,
            about: formRef.current.values.about,
            acceptedEmploymentTypes: getSelectedEmploymentTypes(),

          };
          
          if(formRef.current.values.billingEmail){
            payload = { ...payload,  billingEmail: formRef.current.values.billingEmail }
          }
          let updatedBillingEmail = formRef.current.values.billingEmail == "" ? null : formRef.current.values.billingEmail;
          if(formRef.current.values.InvoiceRecipientContact !== pharmacy.invoiceRecipient || updatedBillingEmail !== pharmacy.billingEmail){
            payload = { ...payload, notifyAdminOnBillingEmailChange: true}
          }
          else{
            payload = { ...payload, notifyAdminOnBillingEmailChange: false}
          }

          console.log("pharmacy detail updated pharmacy", payload);
          const result = await AuthService.updatePharmacy(payload);
          NotificationService.publish(
            NotificationServiceTopic.AccountChanged,
            "account changed "
          );
          setIsEdit(false);
        }
      }
    } catch (err) {
      console.log("onSaveChange err ", err);
      // const error = err as AxiosError;
      // const errorMessage = error.response?.data?.message || error.message;
      const errorMessage = (err as any).response ? (err as any).response.data : (err as any).message;
      setSubmitErrorMessage(errorMessage);
    } finally {
      setLoadingValue(false);
    }
  };
  const onCancelChange = () => {
    setIsEdit(false);
  };
  const handlePaymentMethodChange = (event: React.ChangeEvent<HTMLInputElement>, setFieldValue: (field: string, value: any) => void) => {
      const { name, checked } = event.target;
      setSelectedPaymentMethods((prev) => ({
        ...prev,
        [name]: checked,
      }));
      setFieldValue(name, checked);
    };

  const getSelectedEmploymentTypes = () => {
    const selectedTypes: string[] = [];
    if (selectedPaymentMethods.employee) selectedTypes.push(PreferredEmployeeType.Employee);
    if (selectedPaymentMethods.independentSole) selectedTypes.push(PreferredEmployeeType.ICSoleProprietor);
    if (selectedPaymentMethods.independentIncorporated) selectedTypes.push(PreferredEmployeeType.ICIncorporated);
    return selectedTypes;
  };
  const renderAction = () => {
    return (
      <>
        {isEdit ? (
          <>
            <RBButton
              text="Cancel"
              buttonType={RBButtonType.cancel}
              style={{ marginRight: Spacing.medium }}
              onClick={onCancelChange}
            />
            <RBButton
              text="Save"
              onClick={onSaveChange}
              isLoading={isLoading}
              buttonBackgroundColor={secondaryColor}
            />
          </>
        ) : (
          <RBButton
            text="Edit"
            isLoading={isLoading}
            onClick={async () => {
              await fetchSkills();
              setIsEdit(true);
            }}
            buttonBackgroundColor={secondaryColor}
          />
        )}
      </>
    );
  };
  return (
    <ProfileCardSection
      sectionHeader="Pharmacy Information"
      detail={isEdit ? editDetail() : renderDetail()}
      action={renderAction()}
    />
  );
};
